const analyticsPublish = (event, payload) => {
  try {
    Shopify.analytics.publish(event, payload);
  } catch (e) {
    console.error('analyticsPublish failed:', event, e);
  }
};

document.addEventListener('dealerLocator:results', e => {
  const payload = { dealer_locator: { ...e.detail } };
  window.dataLayer.push({ event: 'dealer_locator_results', ...payload });
  analyticsPublish('decked:dealer_locator_results', payload);
});

document.addEventListener('dealerLocator:search', e => {
  console.log('dealerLocator:search', e.detail);
  const payload = {
    customerId: window.__VPV.customerId,
    dealer_locator: { ...e.detail },
  };
  window.dataLayer.push({ event: 'dealer_locator_search', ...payload });
  analyticsPublish('decked:dealer_locator_search', payload);
});

document.addEventListener('dealerLocator:filter', e => {
  const payload = {
    dealer_locator: { ...e.detail },
  };
  window.dataLayer.push({ event: 'dealer_locator_filter', ...payload });
  analyticsPublish('decked:dealer_locator_filter', payload);
});

document.addEventListener('dealerLocator:contact', e => {
  const payload = {
    dealer_locator: { contact: { ...e.detail } },
  };
  window.dataLayer.push({ event: 'dealer_locator_contact', ...payload });
  analyticsPublish('decked:dealer_locator_contact', payload);
});

document.addEventListener('carousel:view_item', e => {
  const payload = { carousel: { ...e.detail } };
  window.dataLayer.push({ event: 'carousel_view_item', ...payload });
  analyticsPublish('decked:carousel_view_item', payload);
});

document.addEventListener('carousel:scroll_to', e => {
  const payload = { carousel: { ...e.detail } };
  window.dataLayer.push({ event: 'carousel_scroll_to', ...payload });
  analyticsPublish('decked:carousel_scroll_to', payload);
});

document.addEventListener('carousel:slide_to', e => {
  const payload = { carousel: { ...e.detail } };
  window.dataLayer.push({ event: 'carousel_slide_to', ...payload });
  analyticsPublish('decked:carousel_slide_to', payload);
});

document.addEventListener('search:predictive', e => {
  const payload = { search_term: e.detail };
  window.dataLayer.push({ event: 'search_predictive', ...payload });
  analyticsPublish('decked:search_predictive', payload);
});

window.addEventListener('vehicleSubmitted', e => {
  const { make, model, year } = e.detail;
  const payload = { vehicle_make: make, vehicle_model: model, vehicle_year: year };
  window.dataLayer.push({ event: 'vehicle_picker_submit', ...payload });
  analyticsPublish('decked:vehicle_picker_submit', payload);
});

window.addEventListener('variantSelected', e => {
  const { detail } = e;
  if (detail) {
    const currency = Shopify?.currency?.active;
    const productType = detail.product.productType === 'Decked' ? 'Drawers' : detail.product.productType;
    const payload = {
      ecommerce: {
        currency,
        items: [
          {
            item_category: productType,
            item_type: productType,
            item_name: detail.product?.title,
            item_id: detail.id,
            price: detail.priceV2?.amount,
            item_variant: detail.title,
            item_sku: detail.sku,
            quantity: 1,
            currency,
          },
        ],
      },
    };
    window.dataLayer.push({ event: 'select_item', ...payload });
    analyticsPublish('decked:select_item', payload);
  }
});

document.addEventListener("variant:add", e => {
  const { items } = e.detail;
  trackCustomAddToCartEvent(items);
});
document.addEventListener("customizer:variant:add", e => {
  const { item } = e.detail;
  trackCustomAddToCartEvent([item]);
});


//Dialog events
document.addEventListener("dialog:after-hide", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: e.target.tagName?.toLowerCase() }
  };
  window.dataLayer.push({ event: "dialog_close", ...payload });
  analyticsPublish('decked:dialog_close', payload);
});
document.addEventListener("dialog:after-show", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: e.target.tagName?.toLowerCase() }
  };
  window.dataLayer.push({ event: "dialog_open", ...payload });
  analyticsPublish('decked:dialog_open', payload);
});
document.addEventListener("dialog-tray:show", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: "tray" }
  };
  window.dataLayer.push({ event: "dialog_tray_open", ...payload });
  analyticsPublish('decked:dialog_tray_open', payload);
});
document.addEventListener("dialog-tray:hide", e => {
  const payload = {
    dialog: { id: e.target.id, element_type: "tray" }
  };
  window.dataLayer.push({ event: "dialog_tray_close", ...payload });
  analyticsPublish('decked:dialog_tray_close', payload);
});

const trackCustomAddToCartEvent = (items) => {
  if (items.length > 0) {
    const currency = Shopify?.currency?.active;
    const vehicle = VehicleData?.getSelectedVehicle();

    const payload = {
      ecommerce: {
        currency,
        items: items.map(item => {
          return {
            item_category: item.product_type,
            item_type: item.product_type,
            item_name: item.product_title,
            item_photo: item.image,
            item_id: item.variant_id,
            price: (item.price / 100).toFixed(2),
            item_brand: item.vendor,
            item_variant: item.variant_title,
            item_sku: item.sku,
            quantity: item.quantity || 1,
            source: item.source,
            vehicle_make: vehicle?.make,
            vehicle_model: vehicle?.model,
            vehicle_year: vehicle?.year,
            vehicle_body_style: vehicle?.body_style,
            vehicle_bed_length: vehicle?.bed_length
          }
        })
      },
    };
    window.dataLayer.push({ event: "custom_add_to_cart", ...payload });
    analyticsPublish('decked:product_add_to_cart', payload);
  }
}


const cartDrawerEl = document.getElementById('cart-drawer');
if(cartDrawerEl){
  cartDrawerEl.addEventListener('toggle', e => {
    const eventName = e.target.open ? 'mini_cart_open' : 'mini_cart_close';
    window.dataLayer.push({ event: eventName });
    analyticsPublish(`decked:${eventName}`, {});
  });
}
